import { useState, useEffect } from 'react';
import { Modal } from '@mui/material';

import { Buyer, SupplierJobApiResponse } from '@dill/dill-shared';

import { getSupplierBuyers } from '../../../redux/services/supplierBuyersService';

import { useAppDispatch, useAppSelector } from '../../../redux/store';

import RequestInfoSheetForm from './RequestInfoSheetForm';

export const AppSendInfoJobModal = ({
  open,
  handleClose,
  selectedJob,
}: {
  open: boolean;
  handleClose: () => void;
  selectedJob: SupplierJobApiResponse;
}) => {
  const dispatch = useAppDispatch();
  const [requestJobInfoSheet, setRequestJobInfoSheet] = useState<{
    name: string;
    id: string;
    buyerName: string;
    buyer: Buyer | null;
    selectedSupplierJob: SupplierJobApiResponse | null;
    jobNumber: string;
    jobAddress: string;
    jobCity: string;
    jobState: string;
    jobZipCode: string;
    buyerId: string;
    customerJobNumber: string;
    buyerAddress: string;
    buyerCity: string;
    buyerState: string;
    buyerZipCode: string;
  }>({
    name: selectedJob.name || '',
    id: selectedJob.id ?? '',
    buyerId: selectedJob.buyerId || '',
    buyerName: selectedJob?.buyer?.name || '',
    jobNumber: selectedJob.jobNumber || '',
    jobAddress: selectedJob.jobAddress || '',
    jobCity: selectedJob.jobCity || '',
    jobState: selectedJob.jobState || '',
    jobZipCode: selectedJob.jobZipCode || '',
    buyer: selectedJob?.buyer || null,
    selectedSupplierJob: selectedJob || null,
    customerJobNumber: selectedJob.customerJobNumber || '',
    buyerAddress: selectedJob?.buyer?.address || '',
    buyerCity: selectedJob?.buyer?.city || '',
    buyerState: selectedJob?.buyer?.state || '',
    buyerZipCode: selectedJob?.buyer?.zipCode || '',
  });

  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);

  useEffect(() => {
    if (open && user) {
      dispatch(getSupplierBuyers({ supplierId: currentSupplier?.id || '' }));
    }
  }, [open, user?.id]);

  const handleCloseModal = () => {
    setRequestJobInfoSheet({
      name: '',
      buyerId: '',
      jobNumber: '',
      jobAddress: '',
      jobCity: '',
      jobState: '',
      jobZipCode: '',
      buyerName: '',
      id: '',
      buyer: null,
      selectedSupplierJob: null,
      customerJobNumber: '',
      buyerAddress: '',
      buyerCity: '',
      buyerState: '',
      buyerZipCode: '',
    });
    handleClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <>
        <RequestInfoSheetForm
          onClose={handleCloseModal}
          open={open}
          data={{
            name: requestJobInfoSheet.name || '',
            supplierId: currentSupplier?.id ?? '',
            domainId: currentSupplier?.domainId ?? '',
            jobId: requestJobInfoSheet.id ?? '',
            buyerId: requestJobInfoSheet.buyerId || '',
            buyerName: requestJobInfoSheet.buyerName || '',
            jobNumber: requestJobInfoSheet.jobNumber || '',
            jobAddress: requestJobInfoSheet.jobAddress || '',
            jobCity: requestJobInfoSheet.jobCity || '',
            jobState: requestJobInfoSheet.jobState || '',
            jobZipCode: requestJobInfoSheet.jobZipCode || '',
            buyer: requestJobInfoSheet?.buyer || null,
            selectedSupplierJob: requestJobInfoSheet?.selectedSupplierJob || null,
            customerJobNumber: requestJobInfoSheet?.customerJobNumber || '',
            buyerAddress: requestJobInfoSheet?.buyerAddress || '',
            buyerCity: requestJobInfoSheet?.buyerCity || '',
            buyerState: requestJobInfoSheet?.buyerState || '',
            buyerZipCode: requestJobInfoSheet?.buyerZipCode || '',
          }}
        />
      </>
    </Modal>
  );
};
